// Student Editor - PartCPage3 (View-only teacher assessment fields)
import React from 'react';
import { useActivityContext } from '../index';

const PartCPage3 = () => {
  const { activity } = useActivityContext();

  const teacherFields = activity?.part_c?.page_3?.teacher_fields || {};

  const calculateTotal = (category) => {
    if (!category) return 0;
    let total = 0;
    if (category.item_1) total++;
    if (category.item_2) total++;
    if (category.item_3) total++;
    if (category.custom_1_checked) total++;
    if (category.custom_2_checked) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = teacherFields[categoryName] || {};

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#F4824C',
          color: 'black',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '14px',
          padding: '10px 12px',
          backgroundColor: '#FFE5D5',
          minHeight: '100px',
          color: '#666'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #999',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: '#f9f9f9'
              }}>
                {category[`item_${index + 1}`] && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          {category.custom_1 && (
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #999',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: '#f9f9f9'
              }}>
                {category.custom_1_checked && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{category.custom_1}</span>
            </div>
          )}

          {category.custom_2 && (
            <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #999',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '1px',
                backgroundColor: '#f9f9f9'
              }}>
                {category.custom_2_checked && '✓'}
              </div>
              <span style={{ lineHeight: '1.4' }}>{category.custom_2}</span>
            </div>
          )}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '14px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #F4824C',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(category)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{
        width: '100%',
        maxWidth: '1400px',
        minHeight: '80vh',
        margin: '0 auto',
        padding: '40px',
        backgroundColor: 'white',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        borderRadius: '8px',
        boxSizing: 'border-box',
        position: 'relative',
        fontFamily: "'Poppins', Arial, sans-serif"
      }}>
        

        <div style={{
          backgroundColor: '#E3F2FD',
          borderLeft: '4px solid #2196F3',
          padding: '8px 12px',
          marginBottom: '12px',
          fontSize: '14px',
          color: '#1565C0'
        }}>
          📘 Teacher assessment fields are view-only for students
        </div>

        <div style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'center',
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px'
        }}>
          Stage 1
        </div>

        <div style={{
          fontSize: '15px',
          fontWeight: 'bold',
          marginBottom: '12px',
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '6px 12px',
          display: 'inline-block'
        }}>
          Teacher Assessment
        </div>

        <div style={{
          fontSize: '14px',
          marginBottom: '15px',
          padding: '8px 12px',
          backgroundColor: 'white',
          lineHeight: '1.5'
        }}>
          <strong>Step 1:</strong> Choose <strong>two additional parameters</strong> from pages 29-30 for <strong>Stage 1</strong>.<br />
          <strong>Step 2:</strong> Tick (✓) <strong>parameters</strong> that the learner fulfills.
        </div>

        {renderCategory('awareness', 'Awareness', [
          'The learner has conceptual understanding.',
          'There is alignment between research problem and questionnaire.',
          'The learner has identified potential challenges.'
        ])}

        {renderCategory('sensitivity', 'Sensitivity', [
          'The learner understands the larger social purpose of the task.',
          'The questionnaire has inclusive and accessible wording.',
          'There is clear understanding of who the stakeholders are and their needs/concerns.'
        ])}

        {renderCategory('creativity', 'Creativity', [
          'The learner considers alternative methods of collecting findings.',
          'The learner considers alternative groups of respondents as a source of data.',
          'The learner thinks of different ways to motivate respondents to answer.'
        ])}

        <div style={{ marginBottom: '15px' }}>
          <div style={{
            backgroundColor: 'white',
            padding: '6px 0',
            fontWeight: 'bold',
            fontSize: '14px',
            marginBottom: '8px'
          }}>
            Brief comments and pedagogical interventions recommended:
          </div>
          <div style={{
            padding: '10px 12px',
            fontSize: '14px',
            minHeight: '60px',
            backgroundColor: '#FFE5D5',
            lineHeight: '1.4',
            color: '#666'
          }}>
            {teacherFields.brief_comments || 'No comments yet'}
          </div>
        </div>

        
        
      </div>

  );
};

export default PartCPage3;
